import React from "react";
import { Box, Tabs, Tab, Chip } from "@mui/material";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { red, trakrefBlue } from "../../color_utils";
import { trakrefFontFamily } from "../../utils";

const initialNotification = { workOrder: false, location: false, inventory: false, serviceEvent: false };

const tabConfig = [
    { label: "WORK ORDERS", key: "workOrder" },
    { label: "LOCATIONS", key: "location" },
    { label: "INVENTORY", key: "inventory" },
    { label: "SERVICE EVENTS", key: "serviceEvent" }
];

function TabNotificationBadge({count}) {
    return (
        <Chip
            label={count}
            size="small"
            sx={{
                backgroundColor: trakrefBlue,
                color: 'white',
                fontSize: '8px',
                height: '17px',
                width: '17px',
                minWidth: '17px',
                minHeight: '17px',
                borderRadius: '50%',
                marginLeft: '2px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& .MuiChip-label': {
                    padding: 0,
                    lineHeight: 1,
                }
            }}
        />
    );
}

const SearchResultsTab = ({ value, handleChange, notification = initialNotification }) => (
    <Box
        sx={{
            mt: { xs: "32px", md: "16px" },
            width: "100%",
            display: "flex",
        }}
    >
        <Tabs
            value={value}
            onChange={handleChange}
            sx={{
                border: "1px solid #c4c4c4",
                borderRadius: "4px",
                minHeight: "54px",
                width: { xs: "100%", md: "auto" },
                "& .MuiTabs-indicator": {
                    display: "none",
                },
            }}
        >
            {tabConfig.map((tab, idx) => (
                <Tab
                    key={tab.key}
                    label={
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            {tab.label}
                            {notification[tab.key] > 0 && <TabNotificationBadge count={notification[tab.key]} />}
                        </Box>
                    }
                    value={idx}
                    sx={{
                        minHeight: "54px",
                        textTransform: "uppercase",
                        paddingX: { xs: "4px", md: "12px" },
                        fontSize: { xs: "9px", md: "14px" },
                        lineHeight: "22px",
                        fontFamily: trakrefFontFamily,
                        whiteSpace: "nowrap",
                        // US 16740: the Locations tab now appears at every breakpoint (previously
                        // desktop-only). Every tab flexes to fill the row on the mobile breakpoint.
                        flex: { xs: 1, lg: "initial" },
                        maxWidth: { xs: "none", lg: "initial" },
                        borderRight: idx < tabConfig.length - 1 ? "1px solid #c4c4c4" : undefined,
                        backgroundColor: value === idx ? "#f0f0f0" : "white",
                        "&.Mui-selected": {
                            color: "rgba(0, 0, 0, 0.87)",
                            backgroundColor: "#f0f0f0",
                        },
                        "&:hover": {
                            backgroundColor: value === idx ? "#f0f0f0" : "#f5f5f5",
                        },
                    }}
                />
            ))}
        </Tabs>
    </Box>
);

export default SearchResultsTab;
